import scrollMonitor from 'scrollmonitor'
import { requestTimeout } from '../util'

const $panels = $('.our-service__panel')
const $callouts = $('.our-service__callout')

const setupScroll = () => {
  $panels.each((index, el) => {
    const panelWatcher = scrollMonitor.create(el, Math.floor($(el).height() / 2))

    panelWatcher.fullyEnterViewport(() => {
      $('.our-service__panel.panel--active').removeClass('panel--active')
      $(el).addClass('panel--active')
    })
  })

  $callouts.each((index, el) => {
    const calloutWatcher = scrollMonitor.create(el, Math.floor($(el).height() / 2))

    calloutWatcher.fullyEnterViewport(() => {
      $(el).addClass('callout--active')

      $(el).find('li').each((index, el) => {
        const delay = 300 * (index + 1)

        requestTimeout(() => {
          $(el).addClass('item--active')
        }, delay)
      })

      calloutWatcher.destroy()
    })
  })
}

export default {
  can: () => $('body').hasClass('page-our-service'),
  run: () => {
    setupScroll()
  }
}
